import './QrCode.sass';

import React, { FC } from 'react';
import QR from 'react-qrcode-svg';

import { QrCodeProps } from './QrCode.interface';

export const QrCode: FC<QrCodeProps> = (props) => {
  return (
    <div className="QrCode">
      <QR data={props.data} height="100%" width="100%" fgColor="#000" bgColor="#fff" />
    </div>
  );
};
